export default __webpack_public_path__ + "static/media/3.393aacbe.jpg";